import { z } from 'zod';

import { Button, ButtonSegment } from '@poseidon/components/Input2';
import { Communication, Users } from '@poseidon/components/StrokeIcons';

import { ContentDivider } from '@poseidon/components/ContentDivider';
import { useRouterQuery } from '@/hooks/useRouterQuery';

const orgIdSchema = z.enum(['interact', 'data']);
export type ORG_ID = z.infer<typeof orgIdSchema>;
export const convertStringToOrgID = (s: string | undefined, defaultId: ORG_ID): ORG_ID =>
  orgIdSchema.default(defaultId).catch(defaultId).parse(s);

type ViewEditSwitcherProps = {
  defaultId: ORG_ID;
};
export const OrgSwitcher = ({ defaultId }: ViewEditSwitcherProps) => {
  const [query, setQuery] = useRouterQuery();
  const orgId = convertStringToOrgID(query.detailType, defaultId);

  return (
    <ContentDivider size="sm" align="center">
      <ButtonSegment<ORG_ID>
        size="sm"
        selectedId={orgId}
        onChange={(detailType) => setQuery((o) => ({ ...o, detailType }))}>
        <Button id="interact" icon={<Communication.MessageSmileCircle />}>
          Interact
        </Button>
        <Button id="data" icon={<Users.User03 />}>
          Data
        </Button>
      </ButtonSegment>
    </ContentDivider>
  );
};
